import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Editor } from "../Editor";
import { editorStateToHtml, htmlToEditorState } from "./richText.utils";
// Re-exported so the conversion stays reachable where the component is, while
// living in a module a test can import without pulling the whole editor in.
export * from "./richText.utils";
export var RichTextInput = function (_a) {
    var value = _a.value, onChange = _a.onChange, placeholder = _a.placeholder, label = _a.label, error = _a.error, optional = _a.optional;
    var _b = React.useState(function () {
        return htmlToEditorState(value || "");
    }), editorState = _b[0], setEditorState = _b[1];
    // What this editor last handed up. Rebuilding the state from the value on
    // every keystroke would move the caret to the end of the text after each
    // character, so the value is only read back in when it did not come from
    // here: a reset to the default text, or any other outside change. Without
    // this the editor ignored its own value after mount, and "restore the
    // default text" looked like a dead button (Jonas, 2026-10-03).
    var lastEmitted = React.useRef(value || "");
    React.useEffect(function () {
        if ((value || "") === lastEmitted.current) {
            return;
        }
        lastEmitted.current = value || "";
        setEditorState(htmlToEditorState(value || ""));
    }, [value]);
    var handleChange = function (state) {
        setEditorState(state);
        var html = editorStateToHtml(state);
        lastEmitted.current = html;
        onChange(html);
    };
    return (_jsx(Editor, { editorState: editorState, onChange: handleChange, placeholder: placeholder, label: label, error: error, optional: optional }));
};
